import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import {PanelBody,Panel,RangeControl,CheckboxControl,SelectControl,TextControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls, 
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

registerBlockType("template-scripts/leadgen-form",{
  "title":"Contact Form (Lead Gen)",
  "icon":"button",
  "category":"template-scripts",
  attributes:{
    recipient:{
      type:"string",
      default:""
    },
    ctaButton:{
      type:"string",
      default:"Continue"
    },
    alignText:{
      type:"string",
      default:"center"
    },
    recipientEncrypt:{
      type:"string",
      default:""
    },
    subject:{
      type:"string",
      default:"Lead Gen Form"
    },
    spreadsheet:{
      type:"string",
      default:""
    },
    slides:{
      type:"array",
      default:[]
    },
    finalHeadline:{
      type:"string",
      default:"Mahalo for Reaching Out"
    },
    finalText:{
      type:"string",
      default:"Your Message Has Been Sent!"
    },
    ctaHeadline:{
      type:"string",
      default:"Contact Us"
    },
    ctaText:{
      type:"string",
      default:"Let's start a conversation!"
    },
    brandSelection:{
      type:"boolean",
      default:false
    },
    showSidebar:{
      type:"boolean",
      default:false
    },
    isPopup:{
      type:"boolean",
      default:false
    },
    mailchimpListID:{
      type:"string",
      default:""
    },
    mailchimpTags:{
      type:"string",
      default:""
    },
  },

  edit:function({attributes,setAttributes}){
    const form = React.useRef();
    const holder = React.useRef();
    const prevSlideLength = React.useRef(0);
    const [slideIndex,setSlideIndex] = React.useState(0);

    React.useEffect(()=>{
      if(!holder.current) return;
      if(form.current) return;
      form.current = new window.leadGenForm(holder.current,true);
      prevSlideLength.current = attributes.slides.length;

      if(attributes.slides.length == 0){
        //form.current.slideIndex = -1;
        //setSlideIndex(-1); 
        console.log("SET INITIAL INDEX");
        setAttributes({
          slides:[{
            header:"Slide Title",
            fields:[
              {
                type:"input",
                name:"name",
                label:"Name",
                required:true
              },
              {
                type:"input",
                name:"email",
                label:"Email Address",
                required:true
              }
            ], 
            buttonText:"Continue"
          }]
        });

        
      }
    },[]);



    React.useEffect(()=>{
      if(!form.current) return;
      form.current.loadElements();

      if(prevSlideLength.current < attributes.slides.length && attributes.slides.length > 1){
        form.current.slideIndex++;
        console.log("SET NEW SLIDE INDEX: "+slideIndex);
        setSlideIndex(slideIndex+1);
        form.current.showSlide();
      }
      else if(attributes.slides.length == 1){
        setTimeout(()=>{
          setSlideIndex(0);
          form.current.slideIndex = 0;
          form.current.showSlide();
        },100);

        
      }
      
      prevSlideLength.current = attributes.slides.length;

    },[attributes.slides.length]);

    React.useEffect(()=>{
      console.log({slideIndex});
      form.current.slideIndex = slideIndex;
      form.current.showSlide();
    },[slideIndex]);

    const addField = (el) => {
      const fieldType = el.currentTarget.value;
      el.currentTarget.selectedIndex = 0;
      console.log({fieldType});
      var updatedSlides = [...attributes.slides];
      var slide = updatedSlides[form.current.slideIndex];
      var newFields = [...slide.fields,{
        type:fieldType,
        label:"New Field",
        name:false,
        choices:["Choice 1","Choice 2"],
        required:false
      }];
      slide.fields = [...newFields];
      updatedSlides.splice(form.current.slideIndex,1,slide);
      
      setAttributes({
        slides:[...updatedSlides]
      });
    }

    const deleteField = (slideIndex,fieldIndex) => {
      var updatedSlides = attributes.slides;
      updatedSlides[form.current.slideIndex].fields.splice(fieldIndex,1);
      setAttributes({
        slides:[...updatedSlides]
      });
    }

    const updateFieldLabel = (slideIndex,fieldIndex,value) =>{
      var updatedSlides = [...attributes.slides];
      var fields = updatedSlides[form.current.slideIndex].fields;
      fields[fieldIndex].label = value;
      updatedSlides[form.current.slideIndex].fields = [...fields];
      setAttributes({
        slides:[...updatedSlides]
      });
    }

    const updateFieldRequirement = (slideIndex,fieldIndex,required) =>{
      var updatedSlides = attributes.slides;
      updatedSlides[form.current.slideIndex].fields[fieldIndex].required = required;
      setAttributes({
        slides:[...updatedSlides]
      });
    }


    const checkboxChoices = (f,slideIndex,fieldIndex) => {
      var choices = f.choices || ["First Choice","Second Choice"];
      return choices.map((c,choiceIndex)=>{
        return (<>
          <label className="checkbox fullWidth">
            <input type={f.type} disabled={true}/><RichText tagName="span" value={c} onChange={(v)=>updateCheckboxChoice(v,slideIndex,fieldIndex,choiceIndex)}/>
              <br/><a style={{color:"red"}} onClick={()=>deleteCheckboxChoice(slideIndex,fieldIndex,choiceIndex)}>Delete Choice</a>
          </label>
          {(choiceIndex == choices.length - 1) ? (
            <button onClick={()=>addCheckboxChoice(slideIndex,fieldIndex)}>Add Choice</button>
          ) : (<></>)}
        </>);
      });
    };

    const updateCheckboxChoice = (newValue,slideIndex,fieldIndex,choiceIndex) => {
      const slide = attributes.slides[slideIndex];
      const field = slide.fields[fieldIndex];
      if(!field.choices){
        field.choices = [];
      }
      field.choices[choiceIndex] = newValue;
      const updatedSlides = [...attributes.slides];
      updatedSlides[slideIndex].fields[fieldIndex].choices = field.choices;
      setAttributes({
        slides:updatedSlides
      });
    }


    const addCheckboxChoice = (slideIndex,fieldIndex) => {
      const slide = attributes.slides[slideIndex];
      const field = slide.fields[fieldIndex];
      if(!field.choices){
        field.choices = [];
      }
      field.choices.push("New Choice");
      const updatedSlides = [...attributes.slides];
      updatedSlides[slideIndex].fields[fieldIndex].choices = field.choices;
      setAttributes({
        slides:updatedSlides
      });
    }

    const deleteCheckboxChoice = (slideIndex,fieldIndex,choiceIndex) => {
      const slide = attributes.slides[slideIndex];
      const field = slide.fields[fieldIndex];
      field.choices.splice(choiceIndex,1);
      const updatedSlides = [...attributes.slides];
      updatedSlides[slideIndex].fields[fieldIndex].choices = field.choices;
      setAttributes({
        slides:updatedSlides
      });
    }

    const moveField = (e,fieldIndex,direction) => {
      e.preventDefault();
      var slideIndex = form.current.slideIndex;
      
      const updatedSlides = [...attributes.slides];
      const slide = updatedSlides[slideIndex];
      const field = slide.fields[fieldIndex];
      
      if(direction == "up" && fieldIndex > 0){
        // Remove field from current position
        slide.fields.splice(fieldIndex, 1);
        // Insert field at new position (fieldIndex - 1)
        slide.fields.splice(fieldIndex - 1, 0, field);
      }
      else if(direction == "down" && fieldIndex < slide.fields.length - 1){
        // Remove field from current position
        slide.fields.splice(fieldIndex, 1);
        // Insert field at new position (fieldIndex + 1)
        slide.fields.splice(fieldIndex + 1, 0, field);
      }
      updatedSlides[form.current.slideIndex] = slide;
      setAttributes({
        slides: [...updatedSlides]
      }); 
    }

    const updateSelectChoices = (slideIndex,fieldIndex,value) => {
      const slide = attributes.slides[slideIndex];
      const field = slide.fields[fieldIndex];
      field.choices = value;
      const updatedSlides = [...attributes.slides];
      updatedSlides[slideIndex].fields[fieldIndex].choices = field.choices;
      setAttributes({
        slides: [...updatedSlides]
      });
    }

    const updateFieldTag = (slideIndex,fieldIndex,tag) =>{
      var updatedSlides = attributes.slides;
      updatedSlides[form.current.slideIndex].fields[fieldIndex].mailchimpTag = tag;
      setAttributes({
        slides:[...updatedSlides]
      });
    }

    const updateFieldMergeField = (slideIndex,fieldIndex,v) =>{
      var updatedSlides = attributes.slides;
      updatedSlides[form.current.slideIndex].fields[fieldIndex].mailchimpMergeField = v;
      setAttributes({
        slides:[...updatedSlides]
      });
    }

    const slideComponents = attributes.slides.map((s,i)=>{
      const fieldComponents = s.fields.map((f,fi)=>{
        const labelName = f.name ? f.name : f.label.replace(/ /g,"_");
        if(f.type == "input"){
          return (<div className="fieldHolder" key={`slide${i}_field_${fi}`}>
            <div className="deleteField" onClick={()=>deleteField(i,fi)}>&times;</div>
            <RichText tagName="span" style={{textAlign:attributes.alignText,display:"block"}} value={f.label} onChange={(v)=>updateFieldLabel(i,fi,v)}/>
            <input disabled={true} type="text" name={labelName}/>
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldRequirement(i,fi,e.currentTarget.checked)} checked={f.required}/> Required</label>
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldMergeField(i,fi,e.currentTarget.checked)} checked={f.mailchimpMergeField}/> Mailchimp Custom Field</label>
            <div className="field-move-buttons" style={{display: "flex", gap: "5px", marginTop: "5px"}}>
              <button 
                onClick={(e)=>moveField(e,fi,"up")} 
                className="move-btn move-up"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↑</span> Up
              </button>
              <button 
                onClick={(e)=>moveField(e,fi,"down")} 
                className="move-btn move-down"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↓</span> Down
              </button>
            </div>
          </div>);
        }
        else if(f.type == "textarea"){
          return (<div className="fieldHolder" key={`slide${i}_field_${fi}`}>
            <div className="deleteField" onClick={()=>deleteField(i,fi)}>&times;</div>
            <RichText tagName="span" style={{display:"block",textAlign:attributes.alignText}} value={f.label} onChange={(v)=>updateFieldLabel(i,fi,v)}/>
            <textarea disabled={true} name={labelName}></textarea>
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldRequirement(i,fi,e.currentTarget.checked)} checked={f.required}/> Required</label>
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldMergeField(i,fi,e.currentTarget.checked)} checked={f.mailchimpMergeField}/> Mailchimp Custom Field</label>
            <div className="field-move-buttons" style={{display: "flex", gap: "5px", marginTop: "5px"}}>
              <button 
                onClick={(e)=>moveField(e,fi,"up")} 
                className="move-btn move-up"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↑</span> Up
              </button>
              <button 
                onClick={(e)=>moveField(e,fi,"down")} 
                className="move-btn move-down"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↓</span> Down
              </button>
            </div>
          </div>);
        }
        else if(f.type == "select"){
          return (<div className="fieldHolder" key={`slide${i}_field_${fi}`}>
            <div className="deleteField" onClick={()=>deleteField(i,fi)}>&times;</div>
            <RichText tagName="span" style={{display:"block",textAlign:attributes.alignText}} value={f.label} onChange={(v)=>updateFieldLabel(i,fi,v)}/>
            <small>One choice per line:</small>
            <textarea name={labelName} onChange={(e)=>updateSelectChoices(i,fi,e.currentTarget.value)} value={f.choices}/>
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldRequirement(i,fi,e.currentTarget.checked)} checked={f.required}/> Required</label>
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldMergeField(i,fi,e.currentTarget.checked)} checked={f.mailchimpMergeField}/> Mailchimp Custom Field</label>
            <div className="field-move-buttons" style={{display: "flex", gap: "5px", marginTop: "5px"}}>
              <button 
                onClick={(e)=>moveField(e,fi,"up")} 
                className="move-btn move-up"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↑</span> Up
              </button>
              <button 
                onClick={(e)=>moveField(e,fi,"down")} 
                className="move-btn move-down"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↓</span> Down
              </button>
            </div>
          </div>);
        }
        else if(f.type == "checkbox" || f.type == "radio"){
          return (<div className="fieldHolder checkbox" key={`slide${i}_field_${fi}`}>
            <div className="deleteField" onClick={()=>deleteField(i,fi)}>&times;</div>
            <RichText tagName="span" value={f.label} onChange={(v)=>updateFieldLabel(i,fi,v)}/><br/>
            {checkboxChoices(f,i,fi)}
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldRequirement(i,fi,e.currentTarget.checked)} checked={f.required}/> Required</label>
            <label className="requireCheck"><input type="checkbox" onClick={(e)=>updateFieldTag(i,fi,e.currentTarget.checked)} checked={f.mailchimpTag}/> Mailchimp Tag</label>

            <div className="field-move-buttons" style={{display: "flex", gap: "5px", marginTop: "5px"}}>
              <button 
                onClick={(e)=>moveField(e,fi,"up")} 
                className="move-btn move-up"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↑</span> Up
              </button>
              <button 
                onClick={(e)=>moveField(e,fi,"down")} 
                className="move-btn move-down"
                style={{
                  background: "#f1f1f1",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e0e0e0";
                  e.target.style.borderColor = "#ccc";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f1f1f1";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                <span style={{fontSize: "10px"}}>↓</span> Down
              </button>
            </div>
          </div>);
        }
      });





      return (<div className="slide" key={`slide${i}`} data-buttonText={attributes.slides[slideIndex]?.buttonText || "Continue"}>
        <form>
        <RichText tagName="h4" style={{textAlign:attributes.alignText}} value={s.header} onChange={(v)=>updateSlide("header",i,v)}/>
        <RichText tagName="p" style={{textAlign:attributes.alignText}} placeholder="Slide SubText" value={s.subheader} onChange={(v)=>updateSlide("subheader",i,v)}/>
        {fieldComponents}
        <select style={{textAlign:"center",margin:"20px auto 0px auto"}} onChange={(e)=>addField(e)}>
          <option value="">Add Field</option>
          <option value="input">Input Field</option>
          <option value="textarea">Textarea Field</option>
          <option value="checkbox">Checkbox (Multiple Choice)</option>
          <option value="radio">Checkbox (Single Choice)</option>
          <option value="select">Select Box</option>
        </select>
        <TextControl
          label="Custom Button Text"
          value={s.buttonText}
          onChange={(v)=>updateSlide("buttonText",i,v)}
        />  
        </form>
      </div>)
    });



    const updateSlide = (key,index,value) => {
      var updatedSlides = [...attributes.slides];
      updatedSlides[index][key] = value;
      console.log({updatedSlides});

      setAttributes({
        slides:[...updatedSlides]
      });

    };

    const addSlide = (e) => {
      e.preventDefault();
      var updatedSlides = attributes.slides;
      updatedSlides.splice(form.current.slideIndex+1,0,{
        header:"Slide Header",
        fields:[],
        required:false,
        buttonText:attributes.ctaButton
      });
      setAttributes({
        slides:[...updatedSlides]
      });

    }

    const deleteSlide = (e) =>  {
      e.preventDefault();
      var updatedSlides = attributes.slides;
      updatedSlides.splice(form.current.slideIndex,1);
      setAttributes({
        slides:[...updatedSlides]
      });

    }

    return (<>
    <InspectorControls>
      <Panel>
        <PanelBody title="Recipient Information">
          <TextControl
            label="Recipient Email (Separate multiple by comma)"
            value={attributes.recipient}
            onChange={(v)=>{
              setAttributes({
                recipient:v,
                recipientEncrypt:btoa(v)
              });
            }}
          />
          <TextControl
            label="Email Subject Line"
            value={attributes.subject}
            onChange={(v)=>{
              setAttributes({
                subject:v
              });
            }}
          />
        </PanelBody>
        <PanelBody title="Google Spreadsheet ID">
          If you'd like to have all submissions added to a Google Spreadsheet, enter the spreadsheet ID below.  Be sure to give edit privileges (aka Share) to the following email:
          <br/><code style={{maxWidth:"100%",overflowX:"auto"}}>hubhawaiinodejs@hubhawaiinodejs.iam.gserviceaccount.com</code>
          <br/>&nbsp;<br/>
          <TextControl
            label="Google Spreadsheet ID"
            help=""
            value={attributes.spreadsheet}
            onChange={(v)=>{
              setAttributes({
                spreadsheet:v
              });
            }}
          />
        </PanelBody>
        <PanelBody title="Mailchimp Settings">
          <TextControl
            label="Mailchimp List ID"
            value={attributes.mailchimpListID}
            onChange={(v)=>setAttributes({mailchimpListID:v})}
          />    
          <TextControl
            label="Mailchimp Tags"
            help="Separate multiple tags by comma"   
            value={attributes.mailchimpTags}
            onChange={(v)=>setAttributes({mailchimpTags:v})}
          />
        </PanelBody>
        <PanelBody title="Contact Form Layout">
          <CheckboxControl
            checked={attributes.showSidebar}
            onChange={(v)=>setAttributes({showSidebar:v})}
            label="Show Sidebar"
          />
          <CheckboxControl
            checked={attributes.isPopup}
            onChange={(v)=>setAttributes({isPopup:v})}
            label="Popup Version"
          />
          <SelectControl
            label="Text Alignment"
            value={attributes.alignText}
            options={[
              {label:"Left",value:"left"},
              {label:"Center",value:"center"},
              {label:"Right",value:"right"}
            ]}
            onChange={(v)=>setAttributes({alignText:v})}
          />
          <TextControl
            label="CTA Button Text"
            value={attributes.ctaButton}
            onChange={(v)=>setAttributes({ctaButton:v})}
          />
        </PanelBody>
        <PanelBody title="Brand/Market Selection">
          <CheckboxControl
            checked={attributes.brandSelection}
            onChange={(v)=>setAttributes({brandSelection:v})}
            label="Show Market/Brand Selection Slides"
          />
        </PanelBody>
      </Panel>
    </InspectorControls>
    <div {...useBlockProps()}>
    <div className={`leadGenForm inline ${attributes.showSidebar ? `with-sidebar` : ``}`} ref={holder}>
      <div className="holder">
        {attributes.showSidebar ? (<div className="sidebar">
          <RichText tagName="h3" value={attributes.ctaHeadline} onChange={(v)=>setAttributes({ctaHeadline:v})}/>
          <RichText tagName="p" value={attributes.ctaText} onChange={(v)=>setAttributes({ctaText:v})}/>
        </div>) : (<></>)}
        <div className="main">

          <div className="slideHolder">
            {slideComponents}
            <div className="slide">
              <div className="loader"></div>
                <form style={{textAlign:"center",display:"none"}}>
                  <RichText tagName="h3" style={{textAlign:attributes.alignText}} value={attributes.finalHeadline} onChange={(v)=>setAttributes({finalHeadline:v})}/>
                  <RichText tagName="p" style={{textAlign:attributes.alignText}} value={attributes.finalText} onChange={(v)=>setAttributes({finalText:v})}/>
                </form>
            </div>
          </div>
          <div className="buttons" style={{display:"flex",alignItems:"center"}}>
            <a href="#" className="btn-back btn" onClick={()=>setSlideIndex((slideIndex-1) < 0 ? 0 : slideIndex-1)}>Back</a>
            <a href="#slidePrevious" style={{padding:"5px",opacity:slideIndex > 0 ? `1` : `0`}} onClick={()=>setSlideIndex(slideIndex-1)} dangerouslySetInnerHTML={{__html:"&laquo; Previous Slide"}}></a>

            <a href="#" className="btn-next btn teal" style={{cursor:"default",display:slideIndex < attributes.slides.length ? "flex" : "none"}}>
              <RichText tagName="div" value={attributes.slides[slideIndex]?.buttonText || "Continue"}/>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"></path></svg>
            </a>
          </div>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            {slideIndex <= (attributes.slides.length) ? (<>
              <a href="#" onClick={addSlide} style={{padding:"5px",display:(slideIndex < attributes.slides.length) ? "block" : "none"}}>New Slide</a>
              {(slideIndex > 0 && slideIndex <= attributes.slides.length) ? (<a href="#" onClick={deleteSlide} style={{display:slideIndex < attributes.slides.length  && attributes.slides.length > 1 ? "block" : "none",padding:"5px"}}>Delete Slide</a>) : (<></>)}
            </>) : (<></>)} 
            <a href="#slideNext"  style={{display:(slideIndex < attributes.slides.length) ? "block" : "none",padding:"5px"}} onClick={()=>{ setSlideIndex(slideIndex+1); form.current.slideIndex = slideIndex+1; }} dangerouslySetInnerHTML={{__html:(slideIndex) == (attributes.slides.length-1) ? `Confirmation Slide &raquo;` : `Next Slide &raquo;`}}></a>

            
          </div>
        </div>
      </div>
    </div>
    </div>
    </>);
  },
  save:function({attributes}){
    return (<></>);
  }
});
